import React from 'react'

const UserIcon = (props) => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  const style = props.style || {}
  return (
    <svg width={width} height={height} style={style} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" strokeWidth={strokeWidth}>
      <g transform="translate(5.333 4.267)" stroke={color} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="10.334" cy="5.389" r="5.389"/>
        <path d="M17.974 24.533a2.695 2.695 0 0 0 2.587-3.449 10.51 10.51 0 0 0-10.227-7.33 10.51 10.51 0 0 0-10.226 7.33 2.695 2.695 0 0 0 2.6 3.45h15.266z"/>
      </g>
    </svg>
    )
}

export default UserIcon





